import React, { createContext, useState } from 'react';

export const AccordionContext = createContext({
    isActive: 0,
    setIsActive: () => {},
});

const AccordionWrapper = props => {
    const [isActive, setIsActive] = useState(0);

    return (
        <AccordionContext.Provider
            value={{
                isActive,
                setIsActive,
            }}
        >
            {props.children}
        </AccordionContext.Provider>
    );
};

export default AccordionWrapper;
